module.exports = __webpack_public_path__ + "img/tx_zhide.ac370a64.jpg";